var _defs, _rect, _path, _path2, _path3, _rect2, _rect3, _path4, _path5, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaviinci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1292.8 348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#070206;}.cls-2{fill:#cece8a;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1292.8,
    height: 348
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204,246.2l-47.8-94v93.9H133.5l.1-143.5h22.6l60.2,119.3,59.5-120.1h22.5V245.9H275.9V152.1l-47.1,94H204Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.7,246l77.8-143h17.2l77.2,143.1H468.6l-16.2-30.7-10.5-19.5-34-60.9L347.7,246Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M619.7,102.9H645L567.8,246H550.6L472.8,103h26L559,214Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 670.8,
    y: 102.7,
    width: 22.5,
    height: 143.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 739,
    y: 102.7,
    width: 22.5,
    height: 143.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M913.9,212.4V102.6h22.6V246H913.7L823.5,137.3V246H800.1V102.6h21.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1095.7,123.1h-85.8c-10.8.1-16.2,5.4-16.2,16v71.6c-.1,10,5.7,14.9,17.4,14.9h84.5l.1,20.5-91-.1c-22.7.1-34-10.2-34-30.7l.1-82q0-30.9,33.9-30.9h90.9Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1136.8,
    y: 102.7,
    width: 22.5,
    height: 143.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaviinci);
export default __webpack_public_path__ + "static/media/MAVIINCI.53883c4ef60a58d224123344620bf60d.svg";
export { ForwardRef as ReactComponent };